<div class="auth-page">
  <div class="auth-card">

    <div class="auth-logo">
      <ngk-icon icon="shield" size="2rem" color="var(--color-secondary-700)" />
    </div>

    <h1 class="auth-title">Sign in to your account. If we sent you an email please use that email account.</h1>
    <p class="auth-subtitle">Enter your email address and we'll send you a one-time sign-in code.</p>

    <div class="auth-form">
      <ngk-field label="Email address" [fluid]="true">
        <input
          ngkFieldInput
          type="email"
          [value]="email"
          (input)="onEmailInput($event)"
          (keydown)="onKeydown($event)"
          placeholder="you@example.com"
          autocomplete="email"
        />
        <ngk-field-hint>We'll send a 6-digit code to this address</ngk-field-hint>
      </ngk-field>

      @if (error) {
        <p class="error-msg">
          <ngk-icon icon="circle-x" size="0.9rem" color="var(--color-warning-600)" />
          {{ error }}
        </p>
      }

      <button
        ngkButton
        color="secondary"
        mode="solid"
        size="md"
        class="auth-btn"
        [disabled]="!email.trim() || sending"
        (click)="continue()"
      >
        {{ sending ? 'Sending...' : 'Continue' }}
      </button>
    </div>

    <p class="auth-footer">
      By continuing, you agree to Kin's
      <a href="https://www.kin.com/terms/" class="auth-link">Terms of Service</a> and
      <a href="privacy_notice_kin.pdf" target="_blank" class="auth-link">Privacy Notice</a>.
    </p>

  </div>
</div>
